import { PickerItemKind, PickerValue } from 'components/SharedFormComponents/UserAndGroupPicker';

import { ScheduleGroup } from 'utils/api/modules/schedules/schedules.types';
import { UuidableName } from 'utils/api/types';

// Seeds the form's single ordered `assignees` list from the two API fields. Users stay separate from
// group members: folding members in would convert them to named assignees on the next Save.
export const toPickerValues = (users: UuidableName[] = [], groups: ScheduleGroup[] = []): PickerValue[] => [
  ...groups.map((group) => ({
    kind: PickerItemKind.Group as const,
    uuid: group.uuid,
    name: group.name,
    memberCount: group.memberCount,
  })),
  ...users.map((user) => ({ kind: PickerItemKind.User as const, uuid: user.uuid, name: user.name })),
];

export const splitPickerValues = (
  next: PickerValue[]
): { assignedTo: UuidableName[]; assignedGroups: ScheduleGroup[] } => ({
  assignedTo: next.filter((item) => item.kind === PickerItemKind.User).map(({ uuid, name }) => ({ uuid, name })),
  assignedGroups: next
    .filter((item) => item.kind === PickerItemKind.Group)
    .map(({ uuid, name, memberCount }) => ({ uuid, name, memberCount })),
});
